import {
  CityType,
  OffersType,
  OfferType,
  ProfileType,
  ProvinceType
} from "@motorata/base-ui.types.api";

const HOURS_12 = 43200
const DAYS_1 = 86400
const DAYS_2 = 172800
const DAYS_4 = 345600
const WEEK_1 = 604800

async function getProvinces() {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/address/provinces`, {
    next: { revalidate: WEEK_1 },
  })
  return res.json() as Promise<ProvinceType[]>
}

async function getProvince(province: string) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/address/provinces/${province}`, {
    next: { revalidate: WEEK_1 },
  })
  return res.json() as Promise<ProvinceType>
}

async function getCities(province: string) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/address/provinces/${province}/cities`, {
    next: { revalidate: WEEK_1 },
  })
  return res.json() as Promise<CityType[]>
}

async function getCity(province: string, city: string) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/address/provinces/${province}/cities/${city}`, {
    next: { revalidate: WEEK_1 },
  })
  return res.json() as Promise<CityType>
}

async function getProfiles(params: URLSearchParams) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/profiles?` + params, {
    next: { revalidate: DAYS_2 },
  })
  return res.json()
}

async function getProfile(slug: string) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/profile/${slug}`, {
    cache: 'no-store',
    next: { revalidate: 0 },
  })
  return res.json() as Promise<ProfileType>
}

async function getProfileOffers(slug: string, brand: string, model: string, page: number) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/${slug}/offers?page=${page}${brand ? `&brand=${brand}` : ""}${model ? `&model=${model}` : ""}`, {
    next: { revalidate: HOURS_12 },
  })
  return res.json() as Promise<OffersType>
}

async function getOffer(id: string) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/offers/${id}`, {
    next: { revalidate: HOURS_12 },
  })
  return res.json() as Promise<OfferType>
}

async function getOfferCoordinator(id: string) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/offers/${id}/coordinator`, {
    next: { revalidate: WEEK_1 },
  })
  try {
    return res.text()
  }catch (e){
    return null
  }
}

async function getOffers(params: object) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/offers?` + params, {
    next: { revalidate: HOURS_12 },
  })
  return res.json() as Promise<OffersType>
}

async function getOffersCount(params: object) {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/offers-count?` + params, {
    next: { revalidate: HOURS_12 },
  })
  return res.json() as Promise<number>
}

async function rate(type, priceType, year, price, period, payment, repurchase) {
  const res = await fetch(`https://us-central1-mylease-pl.cloudfunctions.net/rateMotoup?type=${type}&priceType=${priceType}&year=${year}&price=${price}&period=${period}&payment=${payment}&repurchase=${repurchase}`, {
    next: { revalidate: DAYS_1 },
  })
  return res.json() as Promise<number>
}

export const GET = {
  getProfile,
  getProfileOffers,
  getProfiles,
  getProvince,
  getProvinces,
  getCities,
  getCity,
  getOffer,
  getOfferCoordinator,
  getOffers,
  getOffersCount,
  rate,
}
